var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { TextControl } from './Text';
import { MoneyControl } from './Money';
import { CheckboxControl } from './Checkbox';
import { StringControl } from './String';
import { ButtonControl } from './Button';
import { DateControl } from './Date';
import { IntegerControl } from './Integer';
import { DropdownControl } from './Dropdown';
import { AttachmentControl } from './Attachment';
import { MultiSelectControl } from './MultiSelect';
import { AutocompleteControl } from './Autocomplete';
import { MaskControl } from './Mask';
import { SliderControl } from './Slider';
import { SliderbarControl } from './Sliderbar';
import { LabelControl } from './Label';
import { ImageControl } from './Image';
import { RadiobuttonControl } from './Radiobutton';
import { PaginatorControl } from './Paginator';
import { PdfControl } from './PdfViewer';
import { LinkControl } from './Link';
import { FileList } from './FileList';
import { MenuControl } from './Menu';
import { IFrameControl } from './IFrame';
import { CameraControl } from './Camera';
export var baseControls = {
    button: function (props) { return React.createElement(ButtonControl, __assign({}, props)); },
    label: function (props) { return React.createElement(LabelControl, __assign({}, props)); },
    image: function (props) { return React.createElement(ImageControl, __assign({}, props)); },
    text: function (props) { return React.createElement(TextControl, __assign({}, props)); },
    string: function (props) { return React.createElement(StringControl, __assign({}, props)); },
    mask: function (props) { return React.createElement(MaskControl, __assign({}, props)); },
    date: function (props) { return React.createElement(DateControl, __assign({}, props)); },
    money: function (props) { return React.createElement(MoneyControl, __assign({}, props)); },
    integer: function (props) { return React.createElement(IntegerControl, __assign({}, props)); },
    slider: function (props) { return React.createElement(SliderControl, __assign({}, props)); },
    sliderbar: function (props) { return React.createElement(SliderbarControl, __assign({}, props)); },
    checkbox: function (props) { return React.createElement(CheckboxControl, __assign({}, props)); },
    autocomplete: function (props) { return React.createElement(AutocompleteControl, __assign({}, props)); },
    dropdown: function (props) { return React.createElement(DropdownControl, __assign({}, props)); },
    multiselect: function (props) { return React.createElement(MultiSelectControl, __assign({}, props)); },
    attachment: function (props) { return React.createElement(AttachmentControl, __assign({}, props)); },
    radiobutton: function (props) { return React.createElement(RadiobuttonControl, __assign({}, props)); },
    paginator: function (props) { return React.createElement(PaginatorControl, __assign({}, props)); },
    pdfViewer: function (props) { return React.createElement(PdfControl, __assign({}, props)); },
    link: function (props) { return React.createElement(LinkControl, __assign({}, props)); },
    fileList: function (props) { return React.createElement(FileList, __assign({}, props)); },
    menu: function (props) { return React.createElement(MenuControl, __assign({}, props)); },
    iframe: function (props) { return React.createElement(IFrameControl, __assign({}, props)); },
    camera: function (props) { return React.createElement(CameraControl, __assign({}, props)); },
};
//# sourceMappingURL=index.js.map